// MUST be the first import in this file. It installs `window.livingsyncs` for
// the Capacitor iPad shell, and `./lib/platform` captures that global ONCE at
// module scope. `./App` below transitively imports platform.ts (via
// lib/apiClient), so any later position here would run too late and the bridge
// would be silently ignored. Inert on the web.
import "./lib/capacitorBridge";
import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { initSentry } from "./lib/sentry";
import { reportKeychainStoreUnavailability } from "./lib/native/keychainTokenStore";
import { reloadOnceForStaleChunk } from "./lib/chunkReload";
import "./lib/cognito"; // Initialize Amplify before any auth calls
import "./surfaces"; // US-009: register all UI surface contributions (side-effect)

// Vite fires `vite:preloadError` on the window when a dynamically-imported
// chunk fails to load (stale hash after a deploy). preventDefault stops Vite
// from rethrowing it as an uncaught error (avoids Sentry noise + any overlay);
// the guarded reload pulls fresh HTML + current chunks. Bounded by a cooldown
// so it can't loop. See src/lib/chunkReload.ts.
// NOTE: preventDefault makes the failed import RESOLVE with `undefined`, so
// it may only be called when a reload is actually happening. Calling it while
// the reload cooldown was active handed lazyNamed an undefined module and
// crashed with "Cannot read properties of undefined (reading 'PageName')"
// (Sentry 7543378748 / 7543774833). With the cooldown active we let the
// rejection propagate so lazyNamed → the error boundary shows the
// "new version available" recovery screen instead.
window.addEventListener("vite:preloadError", (event) => {
  if (reloadOnceForStaleChunk()) event.preventDefault();
});

// Initialize Sentry before rendering
initSentry();

// US-015 AC10 — must run AFTER initSentry(), not as a module-scope side
// effect in keychainTokenStore.ts itself (see that function's own doc
// comment for why: a cycle-2 review caught this exact ordering bug once).
reportKeychainStoreUnavailability();

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
